import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useTheme } from "../../contexts/ThemeContext";

// Syncfusion css
import "../Components/Tables/Customs/syncfusion-grid-overrides.css";

import "@syncfusion/ej2-base/styles/bootstrap5.css";
import "@syncfusion/ej2-buttons/styles/bootstrap5.css";
import "@syncfusion/ej2-dropdowns/styles/bootstrap5.css";
import "@syncfusion/ej2-grids/styles/bootstrap5.css";
import "@syncfusion/ej2-inputs/styles/bootstrap5.css";
import "@syncfusion/ej2-navigations/styles/bootstrap5.css";
import "@syncfusion/ej2-popups/styles/bootstrap5.css";
import "@syncfusion/ej2-react-grids/styles/bootstrap5.css"; // 🔥 Trocar para Bootstrap5!
import "@syncfusion/ej2-splitbuttons/styles/bootstrap5.css";

import {
  AccumulationChartComponent,
  AccumulationDataLabel,
  AccumulationLegend,
  AccumulationSeriesCollectionDirective,
  AccumulationSeriesDirective,
  AccumulationTooltip,
  Inject,
  PieSeries,
} from "@syncfusion/ej2-react-charts";
import { toDateISOStringFormatD } from "../../Services/string.service";

// Icons
import { CiClock2 } from "react-icons/ci";
import { FaEnvelope, FaPhone, FaShippingFast } from "react-icons/fa";
import { HiOutlineTruck } from "react-icons/hi";
import { MdOutlineMotionPhotosPaused } from "react-icons/md";
import { PiClockCountdownLight } from "react-icons/pi";
import { RiFilePaper2Line } from "react-icons/ri";
import { TbRoad } from "react-icons/tb";

//import { useTranslation } from "react-i18next";
import { useTranslation } from "react-i18next";
import { storageKeys } from "../../Constants/storage.key";
import VehiclesStatus from "../../Pages/Vehicles/VehiclesStatus";
import Spinner from "../Components/Spinner";

// Components
import { Footer } from "../../components/Footer";
import { TitleBar } from "../../components/TitleBar";
import { Cards } from "../Components/Cards";

// Services
import { BsHeadset } from "react-icons/bs";
import { useSelected } from "../../contexts/SelectedContext";
import { dashboardService } from "../../Services/dashboard.service";
import { storage } from "../../Services/storage.service";
import "../../styles/dashboardLayout.css";
import { ChartColumnsNormal } from "../Components/Charts/ChartColumnsNormal";
import { ChartColumnsVertical } from "../Components/Charts/ChartColumnsVertical";
import { ChartLineColumns } from "../Components/Charts/ChartLineColumns";
import { ChartStackingColumns } from "../Components/Charts/ChartStackingColumns";
import DriverRankingTable from "../Components/Tables/DriverRankingTable";
import PaginatedTableDashboard from "../Components/Tables/PaginatedTableDashboard";
import homeChartOptions from "./chartOptions";
import searchOptions from "./filterSearch";
import { menusService } from "../../Services/menus.service";
import { getTooltipKeyByChart } from "./chartTooltipMap";

export default function Home() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { isDark } = useTheme();
  const [isLoading] = useState(false);
  const [userSessionData] = useState(storage.get(storageKeys.user_data));
  const [data, setData] = useState([]);
  const [dataStatus, setDataStatus] = useState([]);

  const [sumVehicleCount, setSumVehicleCount] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [vehicleCode, setVehicleCode] = useState(null);

  const [kpiDataValue, setKpiDataValue] = useState([]);
  const [mostActive, setMostActive] = useState([]);
  const [dataOcius, setDataOcius] = useState([]);
  const [dataDrivers, setDataDrivers] = useState([]);
  const [dataChartProgrammer, setDataChartProgrammer] = useState([]);
  const [dataWeek, setDataWeek] = useState([]);
  const [dataSpeeding, setDataSpeeding] = useState([]);

  const [isLoadingKpi, setIsLoadingKpi] = useState(false);
  const { selectedValues } = useSelected();
  const selectedCharts = selectedValues.grafico || [];
  const [allowedMenuIds, setAllowedMenuIds] = useState([]);
  const userSession = storage.get(storageKeys.settings);

  // ✅ Verificar se tem acesso total ao Dashboard
  // LevelId 2, 10, 12, 13 têm acesso total quando allowedMenuIds está vazio
  const userLevelId = userSession?.levelId ? Number(userSession.levelId) : null;
  const hasFullDashboardAccess = allowedMenuIds.length === 0 && 
    userLevelId !== null && 
    [2, 10, 12, 13].includes(userLevelId);

  // Dados KPI para os cards
  // ✅ NOVO: Função que retorna apenas os KPI permitidos
  const getVisibleKpiData = () => {
    const baseKpiData = [
      {
        icon: FaShippingFast,
        label: t("DASHBOARD.ACTIVE_VEHICLES"),
        value: kpiDataValue[0]?.vehicleCount || 0,
        menuId: 90001,
      },
      {
        icon: HiOutlineTruck,
        label: t("DASHBOARD.TOTAL_ODOMETER"),
        value: kpiDataValue[0]?.totalOdometer || 0,
        menuId: 90002,
      },
      {
        icon: TbRoad,
        label: t("DASHBOARD.WORK_HOURS_DISTANCE"),
        value: kpiDataValue[0]?.odometerBusinessHours || 0,
        menuId: 90003,
      },
      {
        icon: PiClockCountdownLight,
        label: t("DASHBOARD.OUTSIDE_WORK_HOURS_DISTANCE"),
        value: kpiDataValue[0]?.odometerNonBusinessHours || 0,
        menuId: 90004,
      },
      {
        icon: CiClock2,
        label: t("DASHBOARD.ENGINE_TIME"),
        value: kpiDataValue[0]?.timeOnMoving || 0,
        menuId: 90005,
      },
      {
        icon: MdOutlineMotionPhotosPaused,
        label: t("DASHBOARD.IDLE_TIME"),
        value: kpiDataValue[0]?.timeOnStopped || 0,
        menuId: 90006,
      },
      {
        icon: MdOutlineMotionPhotosPaused,
        label: t("DASHBOARD.OFF_TIME"),
        value: kpiDataValue[0]?.timeOff || 0,
        menuId: 90007,
      },
      {
        icon: MdOutlineMotionPhotosPaused,
        label: t("DASHBOARD.SPEED_LIMIT_DISTANCE"),
        value: kpiDataValue[0]?.odometerAboveRoadSpeed || 0,
        menuId: 90008,
      },
      {
        icon: MdOutlineMotionPhotosPaused,
        label: t("DASHBOARD.COMPANY_SPEED_LIMIT_DISTANCE"),
        value: kpiDataValue[0]?.odometerAboveCompany || 0,
        menuId: 90009,
      },
      {
        icon: RiFilePaper2Line,
        label: t("DASHBOARD.TOTAL_FINES"),
        value: kpiDataValue[0]?.trafficFines || 0,
        menuId: 0,
      },
    ];

    // ✅ FILTRO: manter apenas KPI com menuId permitido
    // Se tem acesso total (LevelId 2, 10, 12, 13 e array vazio), mostrar todos
    if (hasFullDashboardAccess) {
      // Acesso total: mostrar todos os KPIs (exceto menuId 0)
      return baseKpiData.filter((kpi) => kpi.menuId !== 0 && kpi.menuId);
    }

    // Acesso restrito: filtrar normalmente
    return baseKpiData.filter((kpi) => {
      // Se menuId é 0, pula
      if (kpi.menuId === 0 || !kpi.menuId) {
        return false;
      }

      // Se menuId está em allowedMenuIds, mantém
      return allowedMenuIds.includes(kpi.menuId);
    });
  };

  // ✅ Usar ao renderizar
  const visibleKpiData = getVisibleKpiData();





  // ✅ NOVO: Buscar allowedMenuIds da API
  useEffect(() => {
    const fetchMenuIds = async () => {
      try {
        const responseCharts = await menusService.menusCharts();
        if (responseCharts) {
          const ids = responseCharts.map((item) => item.menuId);
          setAllowedMenuIds(ids);
        }
      } catch (error) {
        console.log("Erro ao buscar menus:", error);
      }
    };

    fetchMenuIds();
  }, []);

  // ✅ FILTRO ATUALIZADO
  const visibleCharts = homeChartOptions.filter((opt) => {
    // Pula gráficos sem menuId ou com menuId 0
    if (opt.menuId === 0 || !opt.menuId) {
      return false;
    }

    // Se tem acesso total (LevelId 2, 10, 12, 13 e array vazio), mostrar todos os selecionados
    if (hasFullDashboardAccess) {
      return selectedCharts.includes(opt.slug) || selectedCharts.includes(opt.menuId);
    }

    // Acesso restrito: verifica se menuId está na API
    if (!allowedMenuIds.includes(opt.menuId)) {
      return false;
    }

    // Verifica se foi selecionado pelo usuário
    return selectedCharts.includes(opt.slug) || selectedCharts.includes(opt.menuId);
  });

  useEffect(() => {
    dispatch({ type: "title", value: t("TITLE.DASHBOARD") });
  }, [dispatch]);

  // Apply chart label colors based on theme
  useEffect(() => {
    const chartElement = document.getElementById("donut-chart-1");
    if (chartElement) {
      const labels = chartElement.querySelectorAll(
        ".e-accumulation-datalabel-text"
      );
      labels.forEach((label) => {
        label.style.fill = isDark ? "#ffffff" : "#000000";
        label.style.color = isDark ? "#ffffff" : "#000000";
      });
    }
  }, [isDark, data]); // Re-run when theme or data changes

  const selectedStartDate = selectedValues.periodo?.[0] || null;
  const selectedGroup = selectedValues.veiculos?.[0] || null;

  useEffect(() => {
    const allData = async () => {
      try {
        setIsLoadingKpi(true);

        const selectedPeriodObj = searchOptions.find(
          (opt) =>
            opt.startDate.getTime() === new Date(selectedStartDate).getTime()
        );

        const dateStart = toDateISOStringFormatD(
          selectedPeriodObj?.startDate || null
        );
        const dateEnd = toDateISOStringFormatD(
          selectedPeriodObj?.endDate || null
        );

        const [
          resultCards,
          resultMostActive,
          resultMostIdle,
          resultRankingDrivers,
          resultAfterHours,
          resultWeeks,
          resultSpeeding,
        ] = await Promise.allSettled([
          dashboardService.byDate(selectedGroup, dateStart, dateEnd),
          dashboardService.mostActive(selectedGroup, dateStart, dateEnd),
          dashboardService.mostIdle(selectedGroup, dateStart, dateEnd),
          dashboardService.rankingDrivers(selectedGroup, dateStart, dateEnd),
          dashboardService.afterHours(selectedGroup, dateStart, dateEnd),
          dashboardService.weeks(selectedGroup, dateStart, dateEnd),
          dashboardService.speeding(selectedGroup, dateStart, dateEnd),
        ]);

        const getValue = (result) =>
          result && result.status === "fulfilled" ? result.value : null;

        const responseCards = getValue(resultCards);
        const responseChartActive = getValue(resultMostActive);
        const responseChartOcious = getValue(resultMostIdle);
        const responseTableDrivers = getValue(resultRankingDrivers);
        const responseAfterHours = getValue(resultAfterHours);
        const responseWeeks = getValue(resultWeeks);
        const responseSpeeding = getValue(resultSpeeding);

        // Atualiza os KPIs mesmo que algum outro endpoint falhe (404, etc.)
        if (responseCards) {
          setKpiDataValue(responseCards);
        }
        if (responseChartActive) {
          setMostActive(responseChartActive);
        }
        if (responseChartOcious) {
          setDataOcius(responseChartOcious);
        }
        if (responseTableDrivers) {
          setDataDrivers(responseTableDrivers);
        }
        if (responseAfterHours) {
          setDataChartProgrammer(responseAfterHours);
        }
        if (responseWeeks) {
          setDataWeek(responseWeeks);
        }
        if (responseSpeeding) {
          setDataSpeeding(responseSpeeding);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoadingKpi(false);
      }
    };
    allData();
  }, [selectedStartDate, selectedGroup]); // Re-run when theme or data changes

  useEffect(() => {
    const carregarStatus = async () => {
      try {
        const json = await dashboardService.chartPizza(selectedGroup);
        const responseStatus = await dashboardService.statusCount();

        setData(
          json.map((item) => ({
            qtd: item.qtd,
            status: item.status,
            statusColor: item.statusColor,
          }))
        );

        setDataStatus(responseStatus);

        setSumVehicleCount(json.reduce((acc, item) => acc + item.qtd, 0));
      } catch (err) {
        console.error("Erro ao buscar status dos veículos:", err);
      }
    };

    carregarStatus();
  }, []);

  // const handlePointClick = (args) => {
  //   const code = args.series.dataSource[args.pointIndex].code;
  //   setVehicleCode(code);
  //   setShowModal(true);
  // };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const dataMultas = [
    {
      motorista: "José Silva Andrade",
      data: "01/01/2020",
      valor: 60,
      placa: "ABCD1234",
    },
    {
      motorista: "José Silva Andrade",
      data: "01/01/2020",
      valor: 60,
      placa: "ABCD1234",
    },
    {
      motorista: "José Silva Andrade",
      data: "01/01/2020",
      valor: 60,
      placa: "ABCD1234",
    },
    {
      motorista: "José Silva Andrade",
      data: "01/01/2020",
      valor: 60,
      placa: "ABCD1234",
    },
    {
      motorista: "José Silva Andrade",
      data: "01/01/2020",
      valor: 60,
      placa: "ABCD1234",
    },
  ];

  const multasColumns = [
    { field: "motorista", headerText: t("TABLE_FINES.DRIVER"), width: "200" },
    { field: "data", headerText: t("TABLE_FINES.DATE"), width: "120" },
    {
      field: "valor",
      headerText: t("TABLE_FINES.VALUE"),
      width: "80",
      textAlign: "Right",
    },
    { field: "placa", headerText: t("TABLE_FINES.PLATE"), width: "80" },
  ];

  // Preparar dados de contato no formato do Dashboard
  const contactData = [
    {
      type: t("HOME.CONTACT_CENTRAL"),
      name: "", // Nao tem nome na central    
      phone:
        userSessionData?.centralPhone !== " - "
          ? userSessionData.centralPhone
          : "",
      email: "", // Nao tem email na central    
    },
    {
      type: t("HOME.CONTACT_COMERCIAL"),
      name:
        userSessionData?.salesRepName !== " - "
          ? userSessionData.salesRepName
          : "",
      phone:
        userSessionData?.salesRepPhone !== " - "
          ? userSessionData.salesRepPhone
          : "",
      email:
        userSessionData?.salesRepEmail !== " - "
          ? userSessionData.salesRepEmail
          : "",
    },
    {
      type: t("HOME.CONTACT_REGIONAL"),
      name:
        userSessionData?.regionalName !== " - "
          ? userSessionData.regionalName
          : "",
      phone:
        userSessionData?.regionalPhone !== " - "
          ? userSessionData.regionalPhone
          : "",
      email:
        userSessionData?.regionalEmail !== " - "
          ? userSessionData.regionalEmail
          : "",
    },
  ];

  // Removido sistema de largura fixa - agora usa CSS puro para responsividade

  // const visibleCharts = homeChartOptions.filter(
  //   (opt) => opt.slug && selectedCharts.includes(opt.slug)
  // );

  // função que renderiza o chart correto para cada opt
  const renderChart = (opt) => {
    if (!opt) return null;
    switch (opt.slug) {
      case homeChartOptions?.[1]?.slug:
        return (
          // <ChartColumnsNormal
          //   id={opt.slug}
          //   data={mostActive}
          //   name={t("DASHBOARD_CHARTS.GREATER_CIRCULATION")}
          //   yName="totalOdometer"
          //   xName="plate"
          // />

          <ChartStackingColumns
            id={opt.slug}
            data={mostActive}
            categorys={2}
            yName1="totalOdometer"
            xName1="plate"
            name1={t("DASHBOARD_CHARTS.GREATER_CIRCULATION")}
            fill1="#26c6da"
            yMin={0}
            yMax={10000}
            yInterval={1000}
            suffix=" km"
          />
        );

      case homeChartOptions?.[2]?.slug:
        return (
          <ChartStackingColumns
            id={opt.slug}
            data={dataOcius}
            categorys={3}
            yName1="stoppedTime"
            yName2="idleTime"
            yName3="movingTime"
            xName1="plate"
            xName2="plate"
            xName3="plate"
            name1={t("DASHBOARD_CHARTS.IDLENESS_DESCRIPTION_IDLE")}
            name2={t("DASHBOARD_CHARTS.IDLENESS_DESCRIPTION_OFF")}
            name3={t("DASHBOARD_CHARTS.IDLENESS_DESCRIPTION_ENGINE")}
            fill1="#f28b82"
            fill2="#FFA500"
            fill3="#27F561"
            yMin={0}
            yMax={400000}
            yInterval={80000}
            suffix=" h"
            isMinutes={true}
          />
        );

      case homeChartOptions?.[3]?.slug:
        return (
          <ChartStackingColumns
            id={opt.slug}
            data={dataChartProgrammer}
            categorys={2}
            yName1="odometerHNComercial"
            yName2="odometerHComercial"
            xName1="plate"
            xName2="plate"
            name1={t("DASHBOARD_CHARTS.OUTSIDE_WORK_HOURS_DESCRIPTION")}
            name2={t("DASHBOARD_CHARTS.INSIDE_WORK_HOURS_DESCRIPTION")}
            fill1="#f28b82"
            fill2="#26c6da"
            yMin={0}
            yMax={10000}
            yInterval={1000}
            suffix=" km"
          />
        );

      case homeChartOptions?.[4]?.slug:
        return (
          <ChartLineColumns
            id={opt.slug}
            data={dataWeek}
            fill1="#8b8bf9"
            fill2="#f28b82"
            fill3="#26c6da"
            fill4="#27F561"
          />
        );

      case homeChartOptions?.[5]?.slug:
        return (
          <ChartStackingColumns
            id={opt.slug}
            data={dataSpeeding}
            categorys={4}
            yName1="odometerSevere"
            yName2="odometerMajor"
            yName3="odometerModerate"
            yName4="odometerCompany"
            name1={t("DASHBOARD_CHARTS.SPEED_ABOVE_50_PERCENT")}
            name2={t("DASHBOARD_CHARTS.SPEED_BETWEEN_20_50_PERCENT_ABOVE")}
            name3={t("DASHBOARD_CHARTS.SPEED_UP_TO_20_PERCENT_ABOVE")}
            name4={t("DASHBOARD_CHARTS.SPEED_ABOVE_COMPANY_LIMIT")}
            xName1="plate"
            xName2="plate"
            xName3="plate"
            xName4="plate"
            fill1="#f28b82"
            fill2="#26c6da"
            fill3="#27F561"
            fill4="#c4c4c4"
            unit="Km"
            suffix=" Evento(s)"
          />
        );

      case homeChartOptions?.[0]?.slug:
        return <DriverRankingTable data={dataDrivers} />;

      case homeChartOptions?.[6]?.slug:
        return (
          <PaginatedTableDashboard
            id="table-multas"
            data={dataMultas}
            columns={multasColumns}
          />
        );

      default:
        return null;
    }
  };

  const formatPhoneNumber = (phone) => {
    // Remove tudo que não é número
    const cleaned = phone?.toString().replace(/\D/g, '') || '';

    // Se não tiver dígitos, retorna vazio
    if (cleaned.length === 0) {
      return '';
    }

    // Formato 1: 11 dígitos (celular) - (12) 9 9999-9999
    if (cleaned.length === 11 && !cleaned.startsWith('0')) {
      return cleaned.replace(/(\d{2})(\d{1})(\d{4})(\d{4})/, '($1) $2 $3-$4');
    }

    // Formato 2: 10 dígitos (fixo) - (12) 9999-9999
    if (cleaned.length === 10) {
      return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }

    // Formato 3: 8 dígitos (0800) - 0800-012-6000
    if (cleaned.length === 8 && cleaned.startsWith('0')) {
      return cleaned.replace(/(\d{4})(\d{3})(\d{1})/, '$1-$2-$3');
    }

    // Formato 4: 10 dígitos com 0800 - 0800-601-2600
    if (cleaned.length === 11 && cleaned.startsWith('0')) {
      return cleaned.replace(/(\d{4})(\d{3})(\d{3})/, '$1-$2-$3');
    }

    // Padrão: retorna o que foi digitado
    return cleaned;
  };

  const mainCards = [
    {
      id: "vehicleStatus",
      title: t("DASHBOARD_CHARTS.VEHICLE_STATUS"),
      menuId: 95001,
      component: "vehicleStatus",
    },
    {
      id: "quickContacts",
      title: t("HOME.QUICK_CONTACT"),
      menuId: 95002,
      component: "quickContacts",
    },
  ];

  // ✅ Filtro: manter apenas os cards com menuId permitido
  const visibleMainCards = mainCards.filter((card) => {
    if (card.menuId === 0 || !card.menuId) {
      return false;
    }

    // Se tem acesso total (LevelId 2, 10, 12, 13 e array vazio), mostrar todos os cards
    if (hasFullDashboardAccess) {
      return true;
    }

    // Acesso restrito: filtrar normalmente
    return allowedMenuIds.includes(card.menuId);
  });

  // Funções auxiliares para verificar se devem renderizar
  const showVehicleStatus = visibleMainCards.some((c) => c.component === "vehicleStatus");
  const showQuickContacts = visibleMainCards.some((c) => c.component === "quickContacts");

  return (
    <>
      {isLoading ? <Spinner /> : ""}

      {!isLoading ? (
        <>
          {!showModal ? (
            <div className="movyx-content has-fixed-filters dashboard-main-container">
              <p className="dashboard-subtitle">
                {t("HOME.UPDATED_AT")}: {new Date().toLocaleString("pt-BR")}
              </p>

              {/* KPI Cards */}
              <Cards data={visibleKpiData} isLoading={isLoadingKpi} />

              <div className="dashboard-top-cards">
                {showVehicleStatus && (
                  <div className="dashboard-card dashboard-main-card">
                    <TitleBar title={t("DASHBOARD_CHARTS.VEHICLE_STATUS")} tooltipKey={"DASHBOARD_CHARTS_VEHICLE_STATUS"} />

                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "0.4fr 0.6fr",
                        height: 400,
                        padding: "1rem",
                        overflow: "hidden",
                      }}
                    >
                      {/* Célula do gráfico */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          minWidth: 0,
                          overflow: "hidden",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <AccumulationChartComponent
                            id={"vehiclesStatusPie"}
                            style={{
                              "--chart-label-color": isDark
                                ? "#ffffff"
                                : "#000000",
                            }}
                            legendSettings={{ visible: false, alignment: "Near" }}
                            tooltip={{ enable: true }}
                            centerLabel={{
                              text: `${sumVehicleCount}`,
                              textStyle: {
                                color: isDark ? "#ffffff" : "#000000", // 👈 aqui você muda a cor
                                fontWeight: "bold",
                                size: "20px",
                              },
                            }}
                            // pointClick={handlePointClick}
                            width="100%"
                            height="100%"
                          >
                            <Inject
                              services={[
                                AccumulationLegend,
                                PieSeries,
                                AccumulationTooltip,
                                AccumulationDataLabel,
                              ]}
                            />
                            <AccumulationSeriesCollectionDirective>
                              <AccumulationSeriesDirective
                                dataSource={data}
                                xName="status"
                                yName="qtd"
                                innerRadius="40%"
                                pointColorMapping="statusColor"
                                dataLabel={{
                                  visible: true,
                                  position: "Outside",
                                  name: "status",
                                  font: {
                                    color: isDark ? "#ffffff" : "#000000",
                                    size: "12px",
                                  },
                                }}
                              />
                            </AccumulationSeriesCollectionDirective>
                          </AccumulationChartComponent>
                        </div>
                      </div>

                      {/* Célula das colunas horizontais */}
                      <div style={{ minWidth: 0, overflow: "hidden" }}>
                        <ChartColumnsVertical
                          data={dataStatus}
                          id={`vehiclesStatusPie-cols`}
                          xName={"statusConnectDescription"}
                          yName={"vehicleCount"}
                          color={"statusConnectColor"}
                        />
                      </div>
                    </div>
                  </div>
                )}

                {showQuickContacts && (
                  <div className="dashboard-card dashboard-contacts-card">
                    <div className="title-contacts">
                      <BsHeadset size={30} />
                      <h2 className="dashboard-card-title">
                      {t("HOME.QUICK_CONTACT")}
                    </h2>
                      <hr />
                    </div>
                    <div
                      className="contacts-list"
                      style={{
                        height: 400,
                        overflowY: "auto",
                        overflowX: "hidden",
                        // padding: "1rem",
                      }}
                    >
                      {contactData.map((contact, i) => (
                        <div key={i} className="contact-item">
                          <div className="contact-type">{contact.type}</div>
                          {contact.name && (
                            <div className="contact-name">{contact.name}</div>
                          )}
                          {contact.phone && (
                            <a
                              href={`tel:${contact.phone}`}
                              className="contact-phone"
                            >
                              <FaPhone />
                              {formatPhoneNumber(contact.phone)}
                            </a>
                          )}
                          {contact.email && (
                            <a
                              href={`mailto:${contact.email}`}
                              className="contact-email"
                            >
                              <FaEnvelope />
                              {contact.email}
                            </a>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              <div className="dashboard-charts-container">
                <div className="dashboard-charts-grid">
                  {visibleCharts.map((opt) => (
                    <div
                      key={opt.slug}
                      className="dashboard-card dashboard-chart-card"
                    >
                      <TitleBar
                        title={t(opt.chart) || t("COMMON.CHART")}
                        tooltipKey={getTooltipKeyByChart(t(opt.chart))}  // Obtém o tooltip automaticamente
                      />
                      <div
                        className="chart-content-wrapper"
                        style={{ height: 400, paddingTop: "1.5rem" }}
                      >
                        {renderChart(opt)}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : (
            <VehiclesStatus
              code={vehicleCode}
              handleCloseModal={handleCloseModal}
            />
          )}
        </>
      ) : (
        ""
      )}
      <Footer />
    </>
  );
}